import { useContext } from "react";
import { featureFlagsContext } from "./context.js";
function useFeatureFlags() {
  const contextData = useContext(featureFlagsContext);
  if (!contextData) {
    throw `Please use '<FeatureFlagsProvider />' before using 'useFeatureFlags()' hook.`;
  }
  return contextData.flags;
}
export {
  useFeatureFlags
};
//# sourceMappingURL=hooks.js.map
